export default __webpack_public_path__ + "static/Danish-Raaz-bb452b4d941393ad25edda9cff6c76cf.png";